const newbornProducts = [
  {
    id: 1,
    title: "CozyCub Baby Sleeping Bag 🧸",
    handle: "cozycub-baby-sleeping-bag",
    variants: [
      { name: "Pink 0-3 Month", id: "47437268680985", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725726562_76e4d525-8ba5-4824-ba88-c1468dbe74ef.png?v=1777059720" },
      { name: "Pink 3-6 Month", id: "50190157676825", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725726562_76e4d525-8ba5-4824-ba88-c1468dbe74ef.png?v=1777059720" },
      { name: "Pink 6-9 Month", id: "50190157709593", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725726562_76e4d525-8ba5-4824-ba88-c1468dbe74ef.png?v=1777059720" },
      { name: "Blue 0-3 Month", id: "47437268648217", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725722396_cb21fb37-eef8-42e9-99fa-6171aba0b61b.png?v=1777059718" },
      { name: "Blue 3-6 Month", id: "50190157742361", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725722396_cb21fb37-eef8-42e9-99fa-6171aba0b61b.png?v=1777059718" },
      { name: "Blue 6-9 Month", id: "50190157775129", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725722396_cb21fb37-eef8-42e9-99fa-6171aba0b61b.png?v=1777059718" },
      { name: "White 0-3 Month", id: "47437268058393", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725717037_14b1f923-b49b-4729-bbb9-50a56bc8e919.png?v=1777059718" },
      { name: "White 3-6 Month", id: "50190157807897", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725717037_14b1f923-b49b-4729-bbb9-50a56bc8e919.png?v=1777059718" },
      { name: "White 6-9 Month", id: "50190157840665", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725717037_14b1f923-b49b-4729-bbb9-50a56bc8e919.png?v=1777059718" }
    ]
  },
  {
    id: 2,
    title: "CubCloud Head Shaping Pillow 🐻‍❄️",
    handle: "cubcloud-head-shaping-pillow",
    variants: [
      { name: "Blue", id: "51446934995225", price: 9.98, comparePrice: 14.99, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/light_grey.jpg?v=1759351337" },
      { name: "Pink", id: "51446935027993", price: 9.98, comparePrice: 14.99, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/pink_fd23177b-2484-46f6-84b7-51897f476abe.jpg?v=1759351337" },
      { name: "Yellow", id: "51446935060761", price: 9.98, comparePrice: 14.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/yellow.jpg?v=1759351337" }
    ],
    defaultImage: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/2_d7c9b9dd-844b-4ed0-ac75-0b59756dc788.jpg?v=1759351337"
  },
  {
    id: 3,
    title: "Butterfly Comfort Nursing Pillow 🦋",
    handle: "butterfly-comfort-nursing-pillow",
    variants: [
      { name: "Pink", id: "50216413757721", price: 34.95, comparePrice: 49.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/51gqicJn-0L.-AC_SL1500.jpg?v=1722639414" },
      { name: "Grey", id: "50216413790489", price: 34.95, comparePrice: 49.99, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_6f0a4b72-93f1-447a-9f4d-378f80bc4fa4.png?v=1712627607" }
    ],
    defaultImage: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20231016-WA0087.jpg?v=1697475434"
  },
  
  {
    id: 4,
    title: "Pandallow 🤍",
    handle: "pandallow",
    defaultImage: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1.jpg?v=1735742378",
    variants: [
      { name: "ZigZag", id: "50165296365849", price: 14.97, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20250201-WA0046.jpg?v=1777063574" },
      { name: "Blue ZigZag", id: "52012817023257", price: 14.97, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_959b261f-1b60-41b6-8e30-ce8f6008ca5a.png?v=1777063964" },
      { name: "Night Sky", id: "50165296398617", price: 14.97, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20250201-WA0047.jpg?v=1777063594" },
      { name: "Pink Stars", id: "50165296431385", price: 14.97, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20250201-WA0048.jpg?v=1777063614" },
      { name: "Grey Stars", id: "50165296464153", price: 14.97, comparePrice: 29.99, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20250201-WA0049.jpg?v=1777063632" },
      { name: "White Stars", id: "50165296496921", price: 14.97, comparePrice: 29.99, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20250201-WA0051.jpg?v=1777063691" },
      { name: "Crown", id: "50165296529689", price: 14.97, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20250201-WA0050.jpg?v=1777063667" }
    ]
  }
];

let newbornStockSynced = false;

async function syncNewbornShopifyStock() {
  for (const product of newbornProducts) {
    try {
      const res = await fetch(`/products/${product.handle}.js`);
      if (!res.ok) continue;

      const data = await res.json();

      product.variants.forEach(variant => {
        const liveVariant = data.variants.find(v => String(v.id) === String(variant.id));
        if (liveVariant) {
          variant.inStock = liveVariant.available;
          variant.price = liveVariant.price / 100;
          variant.comparePrice = liveVariant.compare_at_price ? liveVariant.compare_at_price / 100 : null;
        }
      });
    } catch (error) {
      console.warn("Stock/price sync failed:", product.title);
    }
  }
  newbornStockSynced = true;
}

function getNewbornSavePercentage(price, comparePrice) {
  if (!comparePrice || comparePrice <= price) return null;
  return Math.round(((comparePrice - price) / comparePrice) * 100);
}

function getNewbornDefaultVariant(product) {
  return product.variants.find(v => v.inStock) || product.variants[0];
}

function renderNewbornProducts() {
  const grid = document.getElementById("newbornGrid");
  if (!grid) return;

  grid.innerHTML = "";

  newbornProducts.forEach(product => {
    const firstVariant = getNewbornDefaultVariant(product);
    const displayImage = product.defaultImage || firstVariant.image;
    const savePercent = getNewbornSavePercentage(firstVariant.price, firstVariant.comparePrice);

    const card = document.createElement("article");
    card.className = "newborn-card";

    let dropdownOptions = "";

    product.variants.forEach(variant => {
      const selected = String(variant.id) === String(firstVariant.id) ? "selected" : "";
      const soldOutClass = !variant.inStock ? "sold-out-option" : "";

      dropdownOptions += `
        <option
          value="${variant.id}"
          data-price="${variant.price}"
          data-compare="${variant.comparePrice || ""}"
          data-image="${variant.image}"
          data-title="${product.title}"
          data-instock="${variant.inStock}"
          class="${soldOutClass}"
          ${selected}>
          ${variant.name}
        </option>
      `;
    });

    card.innerHTML = `
      <div class="newborn-card-image-container">
        ${savePercent ? `<span class="sale-badge">SAVE ${savePercent}%</span>` : ""}

        <img src="${displayImage}" alt="${product.title}" class="newborn-card-image" loading="lazy">

        <div class="image-overlay">
          <a href="/products/${product.handle}" class="view-details-btn">
            <svg viewBox="0 0 24 24">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5z"/>
            </svg>
            <span>View Details</span>
          </a>
        </div>

        <button class="image-cart-btn add-to-cart-mobile ${!firstVariant.inStock ? "sold-out-mobile" : ""}"
          data-variant-id="${firstVariant.id}"
          data-title="${product.title}"
          data-price="${firstVariant.price}"
          data-image="${displayImage}"
          ${!firstVariant.inStock ? "disabled" : ""}>
          <svg viewBox="0 0 24 24">
            <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
          </svg>
        </button>

        ${!firstVariant.inStock ? `<div class="mobile-sold-out">Sold Out</div>` : ""}
      </div>

      <div class="newborn-card-info">
        <h3 class="newborn-card-title">${product.title}</h3>

        <div class="variant-selector">
          <select class="variant-dropdown ${!firstVariant.inStock ? "selected-sold-out" : ""}">
            ${dropdownOptions}
          </select>
        </div>

        <div class="newborn-card-price">
          <span class="current-price">$${firstVariant.price.toFixed(2)}</span>
          ${firstVariant.comparePrice ? `<span class="compare-price">$${firstVariant.comparePrice.toFixed(2)}</span>` : ""}
        </div>

        <button class="add-to-cart-btn add-to-cart-desktop ${!firstVariant.inStock ? "sold-out" : ""}"
          data-variant-id="${firstVariant.id}"
          data-title="${product.title}"
          data-price="${firstVariant.price}"
          data-image="${displayImage}"
          ${!firstVariant.inStock ? "disabled" : ""}>
          <svg viewBox="0 0 24 24">
            <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
          </svg>
          <span>${firstVariant.inStock ? "Add to Cart" : "Sold Out"}</span>
        </button>
      </div>
    `;

    grid.appendChild(card);
  });

  attachNewbornEventListeners();
}

function attachNewbornEventListeners() {
  document.querySelectorAll(".variant-dropdown").forEach(dropdown => {
    dropdown.addEventListener("change", function () {
      const card = this.closest(".newborn-card");
      const option = this.options[this.selectedIndex];

      const variantId = option.value;
      const price = parseFloat(option.dataset.price);
      const compare = option.dataset.compare ? parseFloat(option.dataset.compare) : null;
      const image = option.dataset.image;
      const productTitle = option.dataset.title;
      const inStock = option.dataset.instock === "true";

      const imageEl = card.querySelector(".newborn-card-image");
      const priceEl = card.querySelector(".current-price");
      const compareEl = card.querySelector(".compare-price");
      const desktopBtn = card.querySelector(".add-to-cart-desktop");
      const mobileBtn = card.querySelector(".add-to-cart-mobile");
      const imageContainer = card.querySelector(".newborn-card-image-container");

      imageEl.src = image;
      priceEl.textContent = `$${price.toFixed(2)}`;

      if (compareEl) {
        if (compare && compare > price) {
          compareEl.textContent = `$${compare.toFixed(2)}`;
          compareEl.style.display = "inline";
        } else {
          compareEl.style.display = "none";
        }
      }

      desktopBtn.dataset.variantId = variantId;
      desktopBtn.dataset.price = price;
      mobileBtn.dataset.variantId = variantId;
      mobileBtn.dataset.price = price;

      const existingBadge = card.querySelector(".mobile-sold-out");

      if (inStock) {
        this.classList.remove("selected-sold-out");

        desktopBtn.disabled = false;
        desktopBtn.classList.remove("sold-out");
        desktopBtn.querySelector("span").textContent = "Add to Cart";

        mobileBtn.disabled = false;
        mobileBtn.classList.remove("sold-out-mobile");

        if (existingBadge) existingBadge.remove();
      } else {
        this.classList.add("selected-sold-out");

        desktopBtn.disabled = true;
        desktopBtn.classList.add("sold-out");
        desktopBtn.querySelector("span").textContent = "Sold Out";

        mobileBtn.disabled = true;
        mobileBtn.classList.add("sold-out-mobile");

        if (!existingBadge) {
          const badge = document.createElement("div");
          badge.className = "mobile-sold-out";
          badge.textContent = "Sold Out";
          imageContainer.appendChild(badge);
        }
      }
    });
  });

  document.querySelectorAll(".add-to-cart-desktop").forEach(button => {
    button.addEventListener("click", function () {
      if (this.disabled) return;

      const variantId = this.dataset.variantId;
      const title = this.dataset.title;
      const price = parseFloat(this.dataset.price);
      const image = this.dataset.image;

      if (typeof window.addToCart === "function") {
        window.addToCart({
          variant_id: variantId,
          title: title,
          price: price,
          quantity: 1,
          image: image
        });
      } else {
        console.error("window.addToCart is not available");
        alert("Cart is not ready. Please refresh the page.");
      }
    });
  });

  document.querySelectorAll(".add-to-cart-mobile").forEach(button => {
    button.addEventListener("click", function () {
      if (this.disabled) return;

      const variantId = this.dataset.variantId;
      const title = this.dataset.title;
      const price = parseFloat(this.dataset.price);
      const image = this.dataset.image;

      if (typeof window.addToCart === "function") {
        window.addToCart({
          variant_id: variantId,
          title: title,
          price: price,
          quantity: 1,
          image: image
        });
      } else {
        console.error("window.addToCart is not available");
        alert("Cart is not ready. Please refresh the page.");
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  renderNewbornProducts();
  syncNewbornShopifyStock().then(function () {
    renderNewbornProducts();
  });
});